<div class="row mt-2">
    <div class="col-sm-12">
        <div class="float-right">
            <app-advanced-mode id="auditMemberGridAdvancedSwitch" [storageKey]="'audit-member-demographics-list'"
                (collapsibleToggle)="currentEnableAdvanced=$event" class="float-right mr-4 k-dropdown ml-4">
            </app-advanced-mode>
            <span class="float-right mt-1">
                <input id="changesOnly" type="checkbox" [checked]="changesOnly"
                    (change)="onChangesOnlyChange($event.target.checked)" kendoCheckBox class="ml-4 mb-1" />
                <label class="k-checkbox-label k-text-uppercase dark mb-3" for="changesOnly">{{
                    'DEMOGRAPHICS-CHANGES-ONLY' | translate }}
                </label>
            </span>
        </div>
    </div>
</div>
<div class="row mt-2">
    <kendo-grid #grid class="w-100" [data]="gridView" [loading]="loading" [navigable]="true"
        [pageable]="total > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
        [skip]="state.skip" [sortable]="true" [sort]="state.sort" [filterable]="currentEnableAdvanced"
        [filter]="state.filter" [selectable]="{ mode: 'single' }" [columnMenu]="currentEnableAdvanced"
        [resizable]="true" [reorderable]="currentEnableAdvanced" (dataStateChange)="dataStateChange($event)">
        <kendo-grid-column field="userFullName" [width]="100" title="{{ 'USER-NAME' | translate }}">
        </kendo-grid-column>
        <kendo-grid-column field="timestampUTC" [width]="100" title="{{ 'TIMESTAMP' | translate }}" filter="date"
            format="{0:g}">
        </kendo-grid-column>
        <kendo-grid-column field="revisionType" [width]="50" title="{{ 'REVISION-TYPE' | translate }}"
            [columnMenu]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.revisionTypeText}}
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="revisionTypes" filterField="revisionType"
                    textField="text" selectDefaultText="{{ 'SELECT-REVISION' | translate }}" valueField="value">
                </app-dropdown-filter>
            </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="auditType" [width]="50" title="{{ 'AUDIT-TYPE' | translate }}" [columnMenu]="false">
            <ng-template kendoGridCellTemplate let-dataItem>
                {{dataItem.auditTypeText}}
            </ng-template>
            <ng-template kendoGridFilterCellTemplate let-filter>
                <app-dropdown-filter [filter]="filter" [data]="auditTypes" filterField="auditType" textField="text"
                    selectDefaultText="{{ 'SELECT-AUDIT-TYPE' | translate }}" valueField="value">
                </app-dropdown-filter>
            </ng-template>
        </kendo-grid-column>
        <ng-template kendoGridDetailTemplate let-dataItem>
            <app-audit-member-details [enableAdvanced]="currentEnableAdvanced" [changesOnly]="changesOnly"
                [auditType]="dataItem.auditType" [revisionType]="dataItem.revisionType" [memberId]="currentMemberId"
                [revisionId]="dataItem.revisionId">
            </app-audit-member-details>
        </ng-template>
    </kendo-grid>
</div>